<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2229_6270)">
<rect x="2.2" y="7.2" width="33.6" height="15.6" rx="2.3" stroke="currentColor" stroke-width="1.4"/>
<path d="M23.5 13.5C23.5 12.5572 23.5 12.0858 23.7929 11.7929C24.0858 11.5 24.5572 11.5 25.5 11.5H29.5C30.4428 11.5 30.9142 11.5 31.2071 11.7929C31.5 12.0858 31.5 12.5572 31.5 13.5V13.91H23.5V13.5Z" fill="currentColor"/>
<mask id="path-4-inside-1_2229_6270" fill="white">
<path d="M23.5 12.91H31.5V17C31.5 17.9428 31.5 18.4142 31.2071 18.7071C30.9142 19 30.4428 19 29.5 19H25.5C24.5572 19 24.0858 19 23.7929 18.7071C23.5 18.4142 23.5 17.9428 23.5 17V12.91Z"/>
</mask>
<path d="M23.5 12.91H31.5V17C31.5 17.9428 31.5 18.4142 31.2071 18.7071C30.9142 19 30.4428 19 29.5 19H25.5C24.5572 19 24.0858 19 23.7929 18.7071C23.5 18.4142 23.5 17.9428 23.5 17V12.91Z" stroke="currentColor" stroke-width="2.4" mask="url(#path-4-inside-1_2229_6270)"/>
<rect x="24.7002" y="10.3" width="1.3" height="1.43335" fill="currentColor"/>
<rect x="29.0002" y="10.3" width="1.3" height="1.43335" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2229_6270">
<rect width="38" height="30" rx="3" fill="white"/>
</clipPath>
</defs>
</svg>
